import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import ContactDialog from './ContactDialog';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Close mobile menu when route changes
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-6 md:px-10 
      ${isScrolled ? 'glass-effect shadow-soft' : 'bg-gray-900/90 backdrop-blur-sm'}`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img 
            src="/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png" 
            alt="Sparkwave AI Logo" 
            className="h-10 md:h-12 mr-3" 
          />
          <span className="text-2xl font-glacial text-white tracking-wide">SPARKWAVE AI</span>
        </Link>
        
        <nav className="hidden md:flex items-center space-x-8">
          <Link 
            to="/" 
            className={`text-white hover:text-primary transition-colors duration-300 ${location.pathname === '/' ? 'text-primary font-medium' : ''}`}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`text-white hover:text-primary transition-colors duration-300 ${location.pathname === '/about' ? 'text-primary font-medium' : ''}`}
          >
            About
          </Link>
          <Link 
            to="/services" 
            className={`text-white hover:text-primary transition-colors duration-300 ${location.pathname === '/services' ? 'text-primary font-medium' : ''}`}
          >
            Services
          </Link>
          <Link 
            to="/ai-apps" 
            className={`text-white hover:text-primary transition-colors duration-300 ${location.pathname === '/ai-apps' ? 'text-primary font-medium' : ''}`}
          >
            AI Apps
          </Link>
          <Link 
            to="/portfolio" 
            className={`text-white hover:text-primary transition-colors duration-300 ${location.pathname === '/portfolio' ? 'text-primary font-medium' : ''}`}
          >
            Portfolio
          </Link>
          {/* <Link 
            to="/blog" 
            className={`text-white hover:text-primary transition-colors duration-300 ${location.pathname === '/blog' || location.pathname.startsWith('/blog/') ? 'text-primary font-medium' : ''}`}
          >
            Blog
          </Link> */}
          <ContactDialog 
            trigger={
              <Button className="ml-4 btn-hover-effect" variant="default">
                Book Discovery Call
              </Button>
            }
          />
        </nav>
        
        <div className="md:hidden flex items-center">
          <button onClick={toggleMobileMenu} className="text-white p-2">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      <div 
        className={`md:hidden absolute top-full left-0 right-0 bg-gray-900/95 backdrop-blur-md py-6 px-6 
        transition-all duration-300 ease-in-out transform ${mobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'}`}
      >
        <nav className="flex flex-col space-y-4">
          <Link 
            to="/" 
            className={`p-2 text-white transition-colors duration-300 ${location.pathname === '/' ? 'text-primary font-medium' : 'hover:text-primary'}`}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`p-2 text-white transition-colors duration-300 ${location.pathname === '/about' ? 'text-primary font-medium' : 'hover:text-primary'}`}
          >
            About
          </Link>
          <Link 
            to="/services" 
            className={`p-2 text-white transition-colors duration-300 ${location.pathname === '/services' ? 'text-primary font-medium' : 'hover:text-primary'}`}
          >
            Services
          </Link>
          <Link 
            to="/ai-apps" 
            className={`p-2 text-white transition-colors duration-300 ${location.pathname === '/ai-apps' ? 'text-primary font-medium' : 'hover:text-primary'}`}
          >
            AI Apps
          </Link>
          <Link 
            to="/portfolio" 
            className={`p-2 text-white transition-colors duration-300 ${location.pathname === '/portfolio' ? 'text-primary font-medium' : 'hover:text-primary'}`}
          >
            Portfolio
          </Link>
          {/* <Link 
            to="/blog" 
            className={`p-2 text-white transition-colors duration-300 ${location.pathname === '/blog' || location.pathname.startsWith('/blog/') ? 'text-primary font-medium' : 'hover:text-primary'}`}
          >
            Blog
          </Link> */}
          <ContactDialog 
            trigger={
              <Button className="w-full mt-2 btn-hover-effect" variant="default">
                Book Discovery Call
              </Button>
            }
          />
        </nav>
      </div>
    </header>
  );
};

export default Header;
